export default "__VITE_ASSET__5b8e0494__"